import axios from 'axios';

export const verify_recaptcha_token = (recaptcha_token) => {
  const client = axios.create({});
  const url = '/api/v2/storefront/verify_captcha';
  const data = {recaptcha_token};
  return client.post(url, data).then((response) => response.data);
}